import { formatSummaryFeature } from '~pricing/lib/PackageFeatures';

import { SummaryFeatureList, SummaryFeatureRuleMap } from '../types';

const StarterMonthlyFeatureList: SummaryFeatureList = [];

const StarterAnnualOverrideRules: SummaryFeatureRuleMap = {
  // Add feature rule overrides below
  support: () => formatSummaryFeature('email_support'),
  statistical_significance: () => formatSummaryFeature('text_analysis'),
};

export { StarterMonthlyFeatureList, StarterAnnualOverrideRules };
